import { FC, Fragment, Suspense, useState } from 'react';
import { MeterOption } from '../../models/MeterOption';
import { Tooltip } from 'primereact/tooltip';
import { StudentsModal } from './StudentsModal';
import { FilterOptionValues } from './TeacherDashboard';

interface Props {
  value: MeterOption;
  filterOption: FilterOptionValues;
}

export const MeterTemplate: FC<Props> = ({ value, filterOption }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [score, setScore] = useState<number | null | undefined>(undefined);
  const [label, setLabel] = useState<string>('');
  const [isFocused, setIsFocused] = useState(false);
  const openModal = () => {
    if (value.score !== undefined) setScore(value.score);
    setLabel(value.label);
    setModalVisible(true);
  };
  return (
    <Fragment>
      <Tooltip target={`.${value.className}`} mouseTrack position="top" />
      <button
        data-pr-tooltip={`${value.students} Students`}
        className={`${value.className} bar-md text-center border-none tw-text-[#1D1B18] cursor-pointer`}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        style={{
          width: `${value.width}%`,
          minWidth: '7%',
          padding: `${value.width < 10 && '0'}`,
          marginLeft: value.score !== null && value.index !== 0 ? 2 : 0,
          fontFamily: 'Poppins',
          boxShadow: isFocused ? 'inset 0 0 0 3px #6EECBD' : undefined,
        }}
        onClick={openModal}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openModal();
          }
        }}
      >
        {value.label}
      </button>
      {modalVisible && (
        <Suspense>
          <StudentsModal
            filterOption={filterOption}
            label={label}
            score={score}
            visible={modalVisible}
            setModalVisible={setModalVisible}
            header="Daily Snapshot"
            type="day"
          />
        </Suspense>
      )}
    </Fragment>
  );
};
